module.exports = __webpack_public_path__ + "img/33_73.4086b45e.png";